import Joi from 'joi';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const videoBlockSchema = Joi.object({
  type: Joi.string().valid('videosBlock').required(),
  code: Joi.string().allow('', null).required(),
  blocks: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    header: Joi.string().allow('', null),
    mainVideo: Joi.string().allow('', null),
    previewVideo: Joi.string().allow('', null),
    previewImage: Joi.alternatives().try(Joi.string(), Joi.object(imageWithMetaDataSchema)).allow(null, '')
  }))
}).unknown(true);
export default videoBlockSchema;